'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuery = exports.queries = undefined;
var _constants = require('./constants');
var queries = exports.queries = function queries(state) {
  return state[_constants.NAME];
};
var getQuery = exports.getQuery = function getQuery(state, param) {
  var all = queries(state);
  if (Object.prototype.hasOwnProperty.call(all, param)) {
    return all[param];
  }
};